/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M271.093.486c11.658 0 21.119 9.461 21.119 21.119 0 11.657-9.461 21.118-21.119 21.118H43.606v425.522H468.79l-.535-227.77c0-11.685 9.405-21.146 21.09-21.174h.028c11.658 0 21.119 9.405 21.119 21.062l.591 248.944c0 5.604-2.196 11.01-6.167 14.98-3.942 3.97-9.348 6.195-14.951 6.195H22.487c-11.657 0-21.118-9.461-21.118-21.119V21.605C1.369 9.947 10.829.486 22.487.486h248.606zm193.397 14.94l31.762 31.763c19.88 19.907 19.88 52.289.028 72.168l-25.775 25.772a21.248 21.248 0 01-2.49 2.992 21.04 21.04 0 01-3.024 2.524L257.76 357.852c-.22.241-.447.479-.68.712-.251.253-.506.497-.766.734l-3.008 3.006a21.074 21.074 0 01-10.137 5.631l-96.722 22.696a20.246 20.246 0 01-4.815.563 21.102 21.102 0 01-14.952-6.195c-5.153-5.153-7.265-12.615-5.632-19.739l22.696-96.75a21.114 21.114 0 015.631-10.109L392.293 15.455c19.964-19.88 52.29-19.88 72.197-.028zM177.657 308.99l-7.67 32.76 32.742-7.687-25.072-25.073zM378.752 88.73L197.942 269.58l44.184 44.183 180.86-180.818-44.234-44.217zM422.14 45.33l-13.545 13.547 44.242 44.225 13.567-13.564c3.407-3.435 3.407-9.067-.028-12.502l-31.734-31.734c-3.38-3.379-9.01-3.463-12.502.028z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconStartPetition = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconStartPetition.defaultProps = {
  theme,
};
IconStartPetition.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconStartPetition.displayName = 'IconStartPetition';
export { IconStartPetition };
